<template>
    <div class="invalid-feedback">
        <span v-for="(mess, index) in errors" :key="index">{{ mess }} &nbsp;</span>
    </div>
</template>

<script>

export default {
	name: 'IvalidFeedback',
    props: {
		errors: {
			type: Array,
            default: function () {
                return []
            }
        }
    }
}
</script>